import React, {useEffect, useState} from 'react'
import GoogleMapReact from 'google-map-react'
import { MarkerClusterer } from "@googlemaps/markerclusterer"
import CourtEntity from "../../../courts/entities/court.entity"
import { CourtPlayType } from '../../../common/api/api-models'

interface IMapViewModel {
  lat: number
  lng: number
  courts: CourtEntity[]
  onChangeCenter: (lat: number, lng: number) => void
  onSelectCourt: (court: CourtEntity) => void
}

const MapView: React.FC<IMapViewModel> = (props) => {
  const [mapView, setMapView] = useState<any>()
  const [markerCluster, setMarkerCluster] = useState<MarkerClusterer | undefined>()

  useEffect(() => {
    renderCourts()
  }, [mapView])

  useEffect(() => {
    renderCourts()
  }, [props.courts])

  const renderCourts = () => {
    if (mapView !== undefined) {
      if (markerCluster !== undefined) {
        markerCluster.clearMarkers()
      }
      const markers = props.courts.map(
        (court) => {
          const marker = new google.maps.Marker({
            icon: getImageForCourtType(court.playLocation),
            optimized: true,
            position: {
              lat: court.latitude,
              lng: court.longitude,
            },
            map: mapView,
          })
          marker.addListener("click", () => {
            props.onSelectCourt(court)
          });
          return marker
        }
      );

      const mCluster = new MarkerClusterer({
        map: mapView,
        markers,
        renderer: new ClusterRenderer()
      })
      setMarkerCluster(mCluster)
    } else {
      console.log('MAP IS NOT DEFINED!!!!')
    }
  }

  const handleApiLoaded = (map: any, maps: any) => {
    setMapView(map)
  };


  return (
    <div style={{height: 'calc(100VH - 40px)', width: '100VW', borderBottomRightRadius: 10, borderBottomLeftRadius: 10, overflow: "hidden"}}>
    <GoogleMapReact
      bootstrapURLKeys={{ key: 'AIzaSyDrp9cfe22w4lmSru9GbKveLw4fwRmb7fM' }}
      center={{
        lat: props.lat,
        lng: props.lng
      }}
      defaultZoom={11}
      yesIWantToUseGoogleMapApiInternals
      onDragEnd={(map) => {
        props.onChangeCenter(map.center.lat(), map.center.lng())
      }}

      onGoogleApiLoaded={({ map, maps } : any) => handleApiLoaded(map, maps)}
    >
    </GoogleMapReact>
    </div>
  )
}

export default MapView



export const MapIcons = {
  outdoor: require('./images/courtoutdoor.png'),
  indoor: require('./images/courtindoor.png'),
  both: require('./images/courtboth.png')
}

const MARKER_WIDTH = 33
const MARKER_HEIGHT = 31

export const getImageForCourtType = (courtPlayType: CourtPlayType | string): any => {
  switch (courtPlayType) {
    case 'indoor':
      return MapIcons.indoor

    case 'outdoor':
      return MapIcons.outdoor

    case 'both':
      return MapIcons.both

    case 'unknown':
      return MapIcons.both

    default:
      return MapIcons.both
  }
}


class ClusterRenderer {
  render ({ count, position }: any, stats: any) {
    // change color if this cluster has more markers than the mean cluster
    const color = count > Math.max(10, stats.clusters.markers.mean) ? "#D8DF21" : "#87A70D";
    // create svg url with fill color
    const svg = window.btoa(`
  <svg fill="${color}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
    <circle cx="120" cy="120" opacity=".6" r="70" />
    <circle cx="120" cy="120" opacity=".3" r="90" />
    <circle cx="120" cy="120" opacity=".2" r="110" />
  </svg>`);
    // create marker using svg icon
    return new google.maps.Marker({
      position,
      icon: {
        url: `data:image/svg+xml;base64,${svg}`,
        scaledSize: new google.maps.Size(45, 45),
      },
      label: {
        text: String(count),
        color: "rgba(255,255,255,0.9)",
        fontSize: "12px",
      },
      title: `Cluster of ${count} markers`,
      // adjust zIndex to be above other markers
      zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
    });
  }
}
